<script>
import { h } from 'vue'
import BaseLink from './_base-link'

// Vue 3 functional component
export default {
  name: 'NavBarRoutes',
  props: {
    routes: {
      type: Array,
      required: true,
    },
  },
  setup(props, { attrs, slots, emit }) {
    return () => {
      // Return an array of VNodes
      return props.routes.map((route, index) => {
        const title =
          typeof route.title === 'function' ? route.title(h) : route.title

        return h(
          BaseLink,
          {
            key: route.name + index,
            to: route,
            exactActiveClass: 'active',
          },
          () => title
        )
      })
    }
  },
}
</script>
